<template lang="html">
  <div>
    <h1>Bio-bibliographische Nachweise</h1>

    <dl>
      <template v-for="item in sources">
        <dt>{{item.code}}</dt>
        <dd v-if="item.author">{{item.author}}</dd>
        <dd v-if="item.publisher">{{item.publisher}} (Hrsg.)</dd>
        <dd>{{item.title}}</dd>
        <dd v-if="item.pages">S. {{item.pages}}</dd>
        <dd v-if="item.publication">{{item.publication}}</dd>
        <dd v-if="item.notes"><i>{{item.notes}}</i></dd>
      </template>
    </dl>

    <table class="noprint" width="100%">
      <tr>
        <td><hr size="1"></td>
      </tr>
      <tr>
        <td>
          <ul>
            <li><router-link to="/">Datenbank durchsuchen</router-link></li>
          </ul>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['sources'])
  },
  created () {
    if (this.sources.length === 0) {
      this.listSources()
    }
  },
  methods: {
    ...mapActions(['listSources'])
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// SourceList.vue?1353e684